import { render, staticRenderFns } from "./StudipTooltipIcon.vue?vue&type=template&id=09137bea&"
import script from "./StudipTooltipIcon.vue?vue&type=script&lang=js&"
export * from "./StudipTooltipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports